module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('div', {
    staticClass: "nocustomer"
  }, [_c('div', {
    staticClass: "ui-container right aligned"
  }, [_c('div', {
    staticClass: "ui right floated header"
  }, [_vm._v("\n        " + _vm._s(_vm.user.name) + "\n        "), _c('h5', [_vm._v(_vm._s(_vm.user.email))]), _vm._v(" "), _c('button', {
    staticClass: "ui button red",
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('Disconnect')) + "\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "no-customer"
  }, [(_vm.currentCustomer === null) ? _c('button', {
    staticClass: "ui basic button orange"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('No customer selected !')) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "ui basic button green",
    on: {
      "click": _vm.refreshOrders
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('Refresh')) + "\n      ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locale),
      expression: "locale"
    }],
    staticClass: "ui fluid dropdown selection",
    staticStyle: {
      "height": "45px",
      "width": "100px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.locale = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "en"
    }
  }, [_vm._v("English")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "fr"
    }
  }, [_vm._v("French")])])]), _vm._v(" "), (_vm.pendingOrders.length > 0) ? _c('div', {
    attrs: {
      "id": "order-container"
    }
  }, [_vm._l((_vm.pendingOrders), function(order, index) {
    return _c('div', {
      key: index,
      staticClass: "order-item"
    }, [_c('order-view', {
      attrs: {
        "active": _vm.currentOrder == index,
        "home": ""
      },
      on: {
        "click": function($event) {
          return _vm.toggleOrder(index)
        }
      },
      model: {
        value: (_vm.pendingOrders[index]),
        callback: function($$v) {
          _vm.$set(_vm.pendingOrders, index, $$v)
        },
        expression: "pendingOrders[index]"
      }
    })], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "centered my-2"
  }, [_c('div', {
    staticClass: "ui pagination menu wide",
    attrs: {
      "aria-label": "Pagination Navigation",
      "role": "navigation"
    }
  }, [_c('a', {
    staticClass: "item",
    attrs: {
      "aria-current": "false",
      "aria-disabled": "false",
      "tabindex": "0",
      "value": "1",
      "aria-label": "First item",
      "type": "firstItem"
    },
    on: {
      "click": function($event) {
        ;
        (_vm.currentOrderPage = 1) && _vm.getOrders()
      }
    }
  }, [_vm._v("«")]), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "aria-current": "false",
      "aria-disabled": "false",
      "tabindex": "0",
      "value": "",
      "aria-label": "Previous item",
      "type": "prevItem"
    },
    on: {
      "click": function($event) {
        _vm.currentOrderPage-- && _vm.getOrders()
      }
    }
  }, [_vm._v("⟨")]), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "aria-current": "true",
      "aria-disabled": "false",
      "tabindex": "0",
      "value": "currentOrderPage",
      "type": "pageItem"
    },
    on: {
      "click": function($event) {
        ;
        (_vm.currentOrderPage = 1) && _vm.getOrders()
      }
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "aria-current": "false",
      "aria-disabled": "true",
      "tabindex": "-1",
      "value": "",
      "type": "ellipsisItem"
    }
  }, [_vm._v("...")]), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "aria-current": "false",
      "aria-disabled": "false",
      "tabindex": "0",
      "value": "currentOrderPage",
      "type": "pageItem"
    },
    on: {
      "click": function($event) {
        ;
        (_vm.currentOrderPage = _vm.lastOrderPage) && _vm.getOrders()
      }
    }
  }, [_vm._v(_vm._s(_vm.lastOrderPage))]), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "aria-current": "false",
      "aria-disabled": "false",
      "tabindex": "0",
      "value": "",
      "aria-label": "Next item",
      "type": "nextItem"
    },
    on: {
      "click": function($event) {
        _vm.currentOrderPage++ && _vm.getOrders()
      }
    }
  }, [_vm._v("⟩")]), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "aria-current": "false",
      "aria-disabled": "false",
      "tabindex": "0",
      "value": "",
      "aria-label": "Last item",
      "type": "lastItem"
    },
    on: {
      "click": function($event) {
        ;
        (_vm.currentOrderPage = _vm.lastOrderPage) && _vm.getOrders()
      }
    }
  }, [_vm._v("»")])])])], 2) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ad685f72","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = 506
// module chunks = 1